import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const lessonCatalogManifest: FeatureManifest = {
  id: 'lessons-catalog',
  path: 'lessons/catalog/*',
  navPath: '/lessons/catalog',
  label: 'Danh sách bài học',
  description: 'Quản lý chương và bài học',
  navigationGroup: { id: 'lessons', label: 'Bài học' },
  load: () => import('./entry'),
}
